import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { RegisterSW } from "./register-sw";

export function App() {
  return (
    <>
      <RouterProvider router={router} />
      <RegisterSW />
    </>
  );
}
